import { motion } from "framer-motion";

export default function LastOne() {
  const handleCallClick = () => {
    window.location.href = "tel:+491734317404";
  };

  return (
    <div className="max-w-7xl mx-auto flex flex-col lg:flex-row py-20 px-6 md:px-10 gap-12 lg:gap-20 items-center">
      <motion.div
        className="flex-1 flex flex-col gap-6"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-4xl md:text-5xl lg:text-7xl text-darkBlue font-bold leading-tight">
          Wir bauen Gebäude Neu und Um
        </h2>
        <p className="max-w-xl text-gray-500 leading-relaxed">
          Ihr verlässlicher Partner für alle Bauprojekte. Mit einem Jahrzehnt
          Erfahrung und einem Team hochqualifizierter Fachkräfte realisieren wir
          Ihre Visionen - vom individuellen Eigenheim bis zum komplexen
          Gewerbeobjekt.
        </p>
        <motion.button
          onClick={handleCallClick}
          className="self-start px-8 py-3 bg-darkBlue rounded-lg text-white font-medium hover:bg-blue-800 transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Kontakt
        </motion.button>
      </motion.div>

      <motion.div
        className="flex-1 w-full max-w-lg"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.15 }}
      >
        <img
          className="object-cover w-full rounded-lg shadow-lg"
          src="./last-one.png"
          alt="Bauprojekt"
        />
      </motion.div>
    </div>
  );
}
